var _rect, _rect2, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconInsertDriveFileDone = function SvgIconInsertDriveFileDone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 7.25,
    fill: "#FCFCFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 7.25,
    stroke: "#656668",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_2153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5744 9.18365C12.3964 9.18365 11.4433 10.1571 11.4433 11.3469L11.4326 28.6531C11.4326 29.8429 12.3857 30.8163 13.5637 30.8163H26.4255C27.6036 30.8163 28.5674 29.8429 28.5674 28.6531V16.5712C28.5674 15.9979 28.3425 15.4463 27.9355 15.0461L22.763 9.82182C22.3667 9.4108 21.8206 9.18365 21.253 9.18365H13.5744ZM21.0709 15.6735V10.8061L26.961 16.7551H22.1418C21.5528 16.7551 21.0709 16.2684 21.0709 15.6735Z",
    fill: "#313336"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5333 25.2898L16.9292 23.6856C16.7504 23.5069 16.4663 23.5069 16.2875 23.6856C16.1088 23.8644 16.1088 24.1485 16.2875 24.3273L18.2079 26.2477C18.3867 26.4265 18.6754 26.4265 18.8542 26.2477L23.7125 21.394C23.8913 21.2152 23.8913 20.931 23.7125 20.7523C23.5338 20.5735 23.2496 20.5735 23.0708 20.7523L18.5333 25.2898Z",
    fill: "#FCFCFD",
    stroke: "#FCFCFD",
    strokeWidth: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_2153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5102,
    height: 22,
    fill: "white",
    transform: "translate(11.2449 9)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconInsertDriveFileDone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-insert-drive-file-done.b4e525c104af2206c9a0c29717c06ba2.svg";